/* eslint-disable */
import React from 'react';

const IconPaint = () => (
    <svg version="1.1"
         id="paint"
         xmlns="http://www.w3.org/2000/svg"
         x="0px"
         y="0px"
         viewBox="0 0 433.313 433.313">
        <path fill="currentColor" d="M428.273,318.911c-1.249-27.578-12.998-53.165-33.082-72.045c-0.746-0.702-3.213-2.914-3.662-3.313
        c-12.224-10.88-27.942-16.172-44.263-14.91c-0.723,0.056-1.438,0.14-2.154,0.221L61.398,3.818
        c-7.324-5.811-17.931-4.89-24.147,2.093c-6.212,6.98-5.898,17.62,0.716,24.222l254.484,253.99
        c-1.113,17.113,5.078,34.551,18.28,47.123c7.765,7.393,17.347,12.563,27.71,14.95c22.031,5.077,38.76,21.168,43.657,41.994
        c0.435,1.849,0.808,3.724,1.131,5.606c-40.067,17.669-90.358,27.368-142.217,27.368c-16.737,0-33.187-0.984-49.134-2.893
        c-34.587-5.008-66.248-16.091-91.704-32.415c-35.023-22.458-54.249-52.38-54.249-84.255c0-41.526,25.861-73.948,81.282-101.712
        c2.981-1.493,4.352-5.001,3.148-8.11v0c-1.235-3.19-4.75-4.869-8.006-3.821c-33.713,10.854-62.165,26.238-82.558,44.681
        C16.985,253.264,4.929,277.16,4.929,301.742c0,35.799,25.044,69.166,70.519,93.954c32.176,17.54,71.985,29.352,115.275,34.513
        c14.286,2.05,29.008,3.103,43.936,3.103v-0.198c2.114,0.031,4.231,0.049,6.354,0.049c52.574,0,103.441-10.362,144.919-27.454
        c4.978-2.051,13.323-9.171,15.76-11.908C420.085,373.138,429.524,346.542,428.273,318.911z M16.929,301.742
        c0-27.189,17.655-53.165,48.587-73.972c-21.362,21.407-31.619,45.651-31.619,73.83c0,29.086,13.778,56.484,39.304,78.974
        C36.832,358.634,16.929,330.877,16.929,301.742z M46.215,13.888c1.99-2.235,5.384-2.527,7.727-0.669l250.496,198.697
        c-8.723,3.71-16.411,9.454-22.607,16.982c-4.342,5.278-7.714,11.273-10.001,17.688L46.444,21.639
        C44.328,19.527,44.227,16.122,46.215,13.888z M281.506,256.245c1.611-7.241,4.891-14.01,9.591-19.722
        c6.422-7.803,14.844-13.212,24.477-15.773l14.771,11.717c-9.46,3.646-17.878,9.685-24.535,17.773
        c-4.9,5.953-8.448,12.621-10.674,19.609L281.506,256.245z M393.626,384.8c-6.141-24.997-26.194-44.239-52.489-50.298
        c-8.27-1.906-15.923-6.037-22.131-11.948c-17.975-17.116-19.701-45.53-3.931-64.689c8.329-10.119,20.091-16.248,33.119-17.258
        c1.267-0.098,2.529-0.147,3.784-0.147c11.666,0,22.757,4.21,31.57,12.055c0.492,0.439,2.776,2.486,3.422,3.093
        c17.797,16.731,28.208,39.406,29.315,63.847C417.374,343.487,409.336,366.637,393.626,384.8z"/>
    </svg>

);

export default IconPaint;
